module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Hand.72bf8e77.eot";